import {Toast} from "bootstrap";

export function enableAlerts() {
  
    try 
    {
        const toasts = document.querySelectorAll('.toast');

        if (toasts.length === 0)
            return;

        [].slice.call(toasts).map((el: Element) => new Toast(el).show());

    } catch (ex) {
        console.error(ex);
    }

    console.log("[app-behaviors] Installed toasts behavior");
}

